/**
 * 휴대폰번호 하이픈 포맷 — 숫자만 추출 후 국내 휴대폰 규격으로 하이픈 삽입(구앱 `phoneFormatter` 이식).
 * 저장값(raw `01012345678`) 표시 + 입력 라이브 포맷 공용. 부분 입력도 자연스럽게(입력 중 점진 포맷).
 *   11자리 `010-1234-5678`(3-4-4) · 10자리 `011-123-4567`(3-3-4) · 그 외 진행형.
 */
export function formatPhoneNumber(value: string): string {
  const digits = value.replace(/\D/g, '').slice(0, 11);
  if (digits.length <= 3) return digits;
  if (digits.length <= 7) return `${digits.slice(0, 3)}-${digits.slice(3)}`;
  if (digits.length <= 10) return `${digits.slice(0, 3)}-${digits.slice(3, 6)}-${digits.slice(6)}`;
  return `${digits.slice(0, 3)}-${digits.slice(3, 7)}-${digits.slice(7)}`;
}
